<script setup>
defineProps({modelValue: {type: Number, default: null}, schools: {type: Array, default: () => []}, disabled: Boolean});
defineEmits(["update:modelValue"]);
</script>

<template>
    <label class="knowledge-school-select" @click.stop>
        <span>School</span>
        <select :value="modelValue ?? ''" :disabled="disabled" @change="$emit('update:modelValue', $event.target.value === '' ? null : Number($event.target.value))">
            <option value="">Not school related</option>
            <option v-if="modelValue && !schools.some(school => school.id === modelValue)" :value="modelValue" disabled>School #{{ modelValue }} (not in current catalog)</option>
            <option v-for="school in schools" :key="school.id" :value="school.id">{{ school.name }}</option>
        </select>
    </label>
</template>

<style scoped>
.knowledge-school-select { display: flex; flex-direction: column; gap: 5px; max-width: 420px; margin: 8px 0; }
.knowledge-school-select > span { font-size: 12px; color: var(--text-secondary, #64748b); }
.knowledge-school-select select { width: 100%; min-height: 36px; padding: 7px 10px; border: 1px solid var(--border-subtle, #d1d5db); border-radius: 6px; background: var(--bg-surface, #fff); color: var(--text-primary, #172b4d); text-overflow: ellipsis; }
</style>
